module.exports = __webpack_public_path__ + "static/assets/4d250151a07cfc8b54b34e1df68d265c.svg";